// extracted by mini-css-extract-plugin
module.exports = {"wrap":"RegisterPage_wrap__1xgay","titleWrap":"RegisterPage_titleWrap__2zrv7","title":"RegisterPage_title__WCi1f","subTitle":"RegisterPage_subTitle__3nbPU"};